import services from 'services/module';
import {AnimatronPreviews} from './AnimatronPreviewsSvc';

export type ProjectAugmenter = (p: anm.Project) => anm.Project;
function ProjectAugmenter($filter: ng.IFilterService, AnimatronPreviews: AnimatronPreviews) {
    const hasTag = (tags: anm.Tag[], name: string) => tags && tags.some((t: anm.Tag) =>
        t.name.toLowerCase() === name.toLowerCase() && t.type === 'SUPER'
    );

    return (project: anm.Project) => {
        const { Admin, ForeignProjectPermissions }       = options.user.features;
        const foreignRead = ForeignProjectPermissions && ForeignProjectPermissions.read;

        project.name        = $filter('stripTags')(project.name);
        project.description = $filter('stripTags')(project.description);

        project.author = project.author || Object.assign({}, options.anonymous);
        project.owner = project.owner || Object.assign({}, options.anonymous);
        if (project.owner.accountTypes.STUDIO === 'Guest') Object.assign(project.owner, options.anonymous);

        project.likes = project.likes || [];
        project.comments = project.comments || [];
        project.collaborators = (project.collaborators || []).filter((c: anm.User) =>
                !_.contains([project.author.username, project.owner.username], c.username)
        );
        project.isCollaborator = project.collaborators && project.collaborators.some((c: anm.User) =>
                c.username === options.user.username
            );
        project.isOwner = project.owner && options.user.username === project.owner.username;
        project.canEdit = project.editorReadAccess || project.isOwner || foreignRead;

        project.tags        = project.tags || [];
        project.staffPicked = project.staffPicked || hasTag(project.tags, 'Staff Picks');
        project.hallOfFame  = project.hallOfFame || hasTag(project.tags, 'Hall-of-Fame');
        project.contest     = project.contest || project.tags.some((t: anm.Tag) => t.type === 'CONTEST');
        if (!Admin || !Admin.canCreateSuperTags) {
            project.tags = project.tags.filter((t: anm.Tag) => t.type === 'USER');
        }
    };
}

services.factory('ProjectAugmenter', ProjectAugmenter);



// WEBPACK FOOTER //
// ./app/assets/javascripts/services/ProjectAugmenter.ts